// Botão "Instalar o app" (PWA, Android/Chrome).
// Aparece somente quando o navegador dispara beforeinstallprompt, portanto
// nunca aparece em iOS nem quando o app já está instalado (silêncio elegante).
import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { recordEvent } from "../lib/retention";

const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

export const InstallAppButton = ({ className = "" }) => {
  const [deferred, setDeferred] = useState(null);

  useEffect(() => {
    if (isStandalone()) return undefined;
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    const onInstalled = () => setDeferred(null);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!deferred) return null;

  const onClick = async () => {
    recordEvent("click", "pwa-install", { source: "home-hero" });
    deferred.prompt();
    try {
      await deferred.userChoice;
    } finally {
      setDeferred(null);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="install-app-button"
      className={`inline-flex items-center gap-2 border border-gold/70 text-gold px-6 py-3 rounded-full text-sm uppercase tracking-widest hover:bg-gold hover:text-navy transition-colors ${className}`}
    >
      <Download className="w-4 h-4" /> Instalar o app
    </button>
  );
};
